class Tracker {
  category = '';

  setCategory(category) {
    this.category = category;
  }

  getCategory() {
    return this.category;
  }

  track(label, action = 'Clique', tries = 0) {
    try {
      window.UOLPD.Audience.countClick({ category: this.getCategory(), action, label });
    } catch (error) {
      if (tries < 5) {
        setTimeout(() => this.track(label, action, tries + 1), 500);
      }
    }
  }
}


const tracker = new Tracker();

export default tracker;
